module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Summary"
  }, [_c('nav', {
    staticClass: "SummaryBar"
  }, [_c('div', {
    staticClass: "flex justify-end"
  }, [(_vm.showPrices && !_vm.isTotalInvalid) ? _c('div', {
    staticClass: "SummaryBarElement Price Per-Book"
  }, [_c('div', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm._f("price")(_vm.oneBookPrice)))]), _c('div', {
    staticClass: "description"
  }, [_vm._v("Per book")])]) : _vm._e(), (_vm.showPrices) ? _c('div', {
    staticClass: "SummaryBarElement Price"
  }, [(_vm.isTotalInvalid) ? _c('div', {
    staticClass: "price price--invalid"
  }, [_vm._v("Calculating...")]) : _c('div', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm._f("price")(_vm.totalPrice)))]), _c('div', {
    staticClass: "description"
  }, [_vm._v("Total (" + _vm._s(this.currency) + ")")])]) : _vm._e(), (_vm.showPrices && !this.settings.usdConversionRate == 0) ? _c('div', {
    staticClass: "SummaryBarElement Currency"
  }, [_c('span', {
    class: {
      current: this.settings.currency == "USD"
    },
    on: {
      "click": function($event) {
        return _vm.toggleCurrency("USD")
      }
    }
  }, [_vm._v("USD")]), _c('span', [_vm._v(" | ")]), _c('span', {
    class: {
      current: this.settings.currency == "CAD"
    },
    on: {
      "click": function($event) {
        return _vm.toggleCurrency("CAD")
      }
    }
  }, [_vm._v("CAD")])]) : _vm._e(), _c('div', {
    ref: "button",
    staticClass: "SummaryBarElement Toggler",
    class: {
      active: _vm.panelOpened
    },
    on: {
      "click": _vm.togglePanel
    }
  }, [_c('svg', {
    attrs: {
      "width": "10px",
      "height": "6px",
      "viewBox": "0 0 60 36",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M59.21875,31.203125 L31.875,1.20312 C31.61458,0.94271 31.32813,0.76042 31.01562,0.65625 C30.70312,0.55208 30.36459,0.5 30,0.5 C29.63541,0.5 29.29688,0.55208 28.98438,0.65625 C28.67187,0.76042 28.38542,0.94271 28.125,1.20312 L0.78125,31.203125 C0.2604141,31.671877 0,32.257809 0,32.960938 C0,33.664066 0.2604141,34.249998 0.78125,34.71875 C1.250002,35.2395859 1.835934,35.5 2.539062,35.5 C3.242191,35.5 3.828123,35.2395859 4.296875,34.71875 L30,6.59375 L55.70312,34.71875 C56.17188,35.2395859 56.75781,35.5 57.46094,35.5 C58.16407,35.5 58.75,35.2395859 59.21875,34.71875 C59.73959,34.249998 60,33.664066 60,32.960938 C60,32.257809 59.73959,31.671877 59.21875,31.203125 L59.21875,31.203125 Z",
      "fill": "#000000"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Summary")])])])]), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panelOpened),
      expression: "panelOpened"
    }],
    ref: "panel",
    staticClass: "SummaryPanel"
  }, [_c('h3', {
    staticClass: "SectionName"
  }, [_vm._v("Summary")]), _c('table', {
    attrs: {
      "cellspacing": "0"
    }
  }, [_vm._l((_vm.categoriesSummaries), function(categorySummary, catI) {
    return (!_vm.isCategoryIndexDisabled[catI]) ? _c('tr', [_c('td', [_c('p', {
      staticClass: "b"
    }, [_vm._v(_vm._s(categorySummary.category))])]), _c('td', [(_vm.invalidCategoriesIndexes.includes(catI)) ? _c('div', {
      staticClass: "dark-red"
    }, [_vm._v("Unavailable")]) : _c('span', [_vm._v(_vm._s(_vm._f("ratio")(categorySummary.name)))])])]) : _vm._e()
  }), _c('tr', [_c('td', {
    staticClass: "b pb3"
  }, [_vm._v("Pages per book")]), _c('td', [_vm._v(_vm._s(_vm.quantities.pages))])]), _c('tr', [_c('td', {
    staticClass: "b pb3"
  }, [_vm._v("Number of books")]), _c('td', [_vm._v(_vm._s(_vm.quantities.books))])])], 2), (_vm.showPrices) ? _c('hr') : _vm._e(), (_vm.discountPrice > 0) ? _c('div', [_c('table', {
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "b pb3"
  }, [_vm._v("Pre-total")]), _c('td', [(_vm.isTotalInvalid) ? _c('div', {
    staticClass: "dark-red"
  }, [_vm._v("?")]) : _c('span', [_vm._v(_vm._s(_vm._f("price")(_vm.preTotalPrice)))])])])]), _c('table', {
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "b pb3"
  }, [_vm._v("Quantity discount")]), _c('td', [(_vm.isTotalInvalid) ? _c('div', {
    staticClass: "dark-red"
  }, [_vm._v("?")]) : _c('span', [_vm._v("- " + _vm._s(_vm._f("price")(_vm.discountPrice)))])])])])]) : _vm._e(), (_vm.showPrices) ? _c('table', {
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "b pb2"
  }, [_vm._v("Total per book")]), _c('td', [(_vm.isTotalInvalid) ? _c('div', {
    staticClass: "dark-red"
  }, [_vm._v("?")]) : _c('span', [_vm._v(_vm._s(_vm._f("price")(_vm.oneBookPrice)) + " " + _vm._s(_vm.currency))])])]), _c('tr', [_c('td', {
    staticClass: "b pb2"
  }, [_vm._v("Total")]), _c('td', {
    staticClass: "b"
  }, [(_vm.isTotalInvalid) ? _c('div', {
    staticClass: "dark-red"
  }, [_vm._v("?")]) : _c('span', [_vm._v(_vm._s(_vm._f("price")(_vm.totalPrice)) + " " + _vm._s(_vm.currency))])])])]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fb070bb2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookartSummary/BookartSummary.vue
// module id = 195
// module chunks = 2